import Rollbar from "rollbar";
import uploadImage from "./uploadImage";
import { User } from "../types";

var rollbar = new Rollbar({
    accessToken: process.env.NEXT_PUBLIC_ROLLBAR_ACCESS_TOKEN,
});

export type UserDocProps = {
    doc: User,
    errors?: any[],
};

export default async function saveUser(u: User, qs?: string): Promise<UserDocProps> {
    const user = { ...u };
    if (user.email) {
        user.email = user.email.toLowerCase();
    }

    if (user.mackertag && user.mackertag.startsWith('@')) {
        user.mackertag = user.mackertag.replace('@', '');
    }

    delete user.image;
    delete user.trophies;
    delete user.friends;
    delete user.administer;
    delete user.createdBy;
    delete user.createdAt;
    delete user.updatedAt;

    if (user.id) {
        if (!user.canEdit) {
            delete user.height;
            delete user.experience;
            delete user.fname;
            delete user.lname;
            delete user.dob;
        }

        delete user.canEdit;

        if (user.imageUpload) {
            try {
                const image = await uploadImage(user.imageUpload, user.image ? user.image.id : null);
                if (image.errors) {
                    return  { doc: null, errors: image.errors };
                }
                image && (user.image = image);
            } catch (err) {
                rollbar.error(err);
                return { doc: null, errors: [err] };
            }
        }

        try {
            const req = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/user/${user.id}${qs ? `?${qs}` : ''}`, {
                method: "PATCH",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(user),
            });
            const data = await req.json();

            if (data.errors) {
                return { doc: null, errors: data.errors };
            }
            return data;
        } catch (err) {
            rollbar.error(err);
            return { doc: null, errors: [err] };
        }
    } else {
        try {
            const req = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/user`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(user),
            })
            const data = await req.json();
            if (data.errors) {
                rollbar.error(data.errors);
                return { doc: null, errors: data.errors };
            }
            return data;
        } catch (err) {
            rollbar.error(err);
            return { doc: null, errors: [err] };
        }
    }
}